import React from 'react';
import { IDateInput } from '../../../redux/slices/oldBuilder/date/types';
import { useAppDispatch, useAppSelector } from '../../../redux/hooks';
import DatePickerWidget from '../DatePickerWidget';
import styled from 'styled-components';
import { setSelectedDateInput } from '../../../redux/slices/oldBuilder';

import { builderDateSelector } from '../../../redux/selectors/date';
import {
  activeSchemaIdSelector,
  builderDateConfigSelector,
} from '../../../redux/selectors/builder';

const Container = styled.div`
  align-self: flex-start;
  flex: 0 0 auto;
  display: flex;
  gap: 12px;
`;

const BuilderExecutionDateRange = () => {
  const dispatch = useAppDispatch();
  const dateInput = useAppSelector(builderDateSelector);
  const activeSchemaId = useAppSelector(activeSchemaIdSelector);
  const dateConfig = useAppSelector(builderDateConfigSelector);

  const handleChange = (newDateInput: IDateInput) => {
    dispatch(setSelectedDateInput({ newDateInput }));
  };

  return (
    <Container>
      <DatePickerWidget
        endDate={dateConfig.maxDate}
        dateInput={dateInput}
        onChange={handleChange}
        schemaId={activeSchemaId}
      />
    </Container>
  );
};

export default BuilderExecutionDateRange;
